import Sticky from 'react-stickynode';
import {
  DetailScholarship,
  GGSheetScholarshipsData
} from './DetailScholarships';
import * as React from 'react';
import styled from 'styled-components';
import { useStickyCourseContext } from './StickyCourseContext';
import { Container } from '../../../components/withMarketingSection';

const StickyGGSheetScholarshipsWrapper = styled.div`
  width: 352px;
  height: 0px;

  .sticky-inner-wrapper {
    left: calc((100vw - 1120px) / 2 + 740px + 18px);
  }

  ${Container} {
    display: flex;
    justify-content: end;
    padding-left: 24px;
  }
`;
export const StickyGGSheetScholarships = ({ level, syllabus, rating }) => {
  const { isEnabled } = useStickyCourseContext();
  const [zIndex, setZIndex] = React.useState(500);

  if (!isEnabled) {
    return null;
  }
  return (
    <GGSheetScholarshipsData level={level} syllabus={syllabus} rating={rating}>
      <StickyGGSheetScholarshipsWrapper>
        <Sticky
          top={20}
          innerZ={zIndex}
          bottomBoundary="#course-landing-detail-bottom"
          onStateChange={state => {
            if (state.status === Sticky.STATUS_FIXED) {
              setZIndex(500);
            }
            if (state.status === Sticky.STATUS_RELEASED) {
              setZIndex(400);
            }
          }}
        >
          <DetailScholarship showVideo={false} />
        </Sticky>
      </StickyGGSheetScholarshipsWrapper>
    </GGSheetScholarshipsData>
  );
};
